import { InPlaceDropDownEditor } from "@etframework/ui.components";
import { useClients } from "../../data/queries/clientQueries";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { useTranslation } from "react-i18next";

export const ClientsDropdownInPlaceEditor = ({
  id,
  value,
  actionSuccess,
  disabled,
  ...rest
}) => {
  const { data: clients, isPending: isClientsPending } = useClients();
  const { t } = useTranslation(["Overlay"]);

  if (isClientsPending)
    return (
      <SkeletonComponent
        height={"1.3em"}
        width={"300px"}
        className="my-2 mx-2"
        shimmerEffect="Fade"
      />
    );
  return (
    <InPlaceDropDownEditor
      id={id}
      value={
        isClientsPending ? null : value
      } /* Prevent showing ID as display value */
      disabled={isClientsPending || disabled}
      fields={{ text: "FullName", value: "Id" }}
      dataSource={clients}
      placeholder={t("ClientPlaceholder")}
      model={{ showClearButton: false }}
      actionSuccess={actionSuccess}
      {...rest}
    />
  );
};
